module.exports = __webpack_public_path__ + "static/tarrasque-baec88055ef923a69dc0216a268c6523.jpeg";